import styled from 'styled-components';
import { Divider, token } from '@bynder/design-system';

export const StyledDivider = styled(Divider)`
    margin-left: calc(-1 * ${token.spacing6});
    margin-right: calc(-1 * ${token.spacing6});
`;
